import {MuWidget} from "mu-widget/lib/MuWidget";
import {Account} from "../../types";
import {DataStore} from "../../DataStore";
import {ErrorListMessage, ErrorMarker} from "mu-widget/lib/utils/ErrorMarker";
import {Passwords} from "mu-js-utils/lib/Passwords";
import {ErrorList} from "mu-widget/lib/utils/ErrorList";
import {addFlash, redirect} from "../../utils";
import {BaseAppWidget} from "./BaseAppWidget";
import {t} from "../../translate";

export class UiSign extends BaseAppWidget
{
    // @ts-ignore
    private errorMarker: ErrorMarker;
    public email: string | null = null;
    public tokenWithId: string | null = null;
    // @ts-ignore
    private appUrl: string;
    private trainers: { name: string, email: string, token: string, id: number }[] = [];
    beforeIndex() {
        this.muVisible(false, '.');
        this.muAppendContent(
            `
            <div class="d-flex-column min-height-100dvh">
                ` + this.hcHeader() + `
                <div class="l-app-content flex-grow-0" mu="content">
                    <div class="text-align-center" mu="pStart">
                        <strong>${t('appTitle')}</strong>
                        <p class="c-panel">
                            ${t('signActionStartInfo')}
                        </p>
                        <p class="c-panel">
                            ${t('signStartLoginInfo')}
                            <a class="d-block btn--primary" mu-click='bAction: login, true'>${t('signStartLogin')}</a>
                        </p>
                        <p class="c-panel">
                            ${t('signStartRegisterOrResetInfo')}
                            <a class="d-block btn--primary" mu-click="bAction: registerOrRecovery, true">${t('signStartRegisterOrReset')}</a>
                        </p>
                    </div>
                    <div mu-id="logged" class="c-message">
                        <div mu-id="loggedInfo">${t('signStatusLoggedInAs')}</div>
                        <strong mu-id="loggedEmail"></strong>.

                        <button class="d-block btn--secondary mb-1rem w-100p" mu-id="bLogout">${t('signButtonLogout')}</button>
                        <button class="d-block btn--secondary mb-1rem w-100p" mu-id="bToApp">${t('signButtonGoToApp')}</button>
                    </div>
                    <div class="c-message" mu="message">
                    </div>
                    <div mu-id="noLogged">
                        <form class="form" mu="form" method="post">
                            <div class="c-form-pair">
                                <label mu-for="email" class="form-label">${t('signLabelEmail')}</label>
                                <input type="email" class="form-control" mu-id="email" mu-bind="email" autocomplete="email" name="email" />
                                <div class="error-message" mu-for="error:email"></div>
                            </div>
                    
                            <div class="c-form-pair" mu-id="pPassword">
                                <label mu-for="password" class="form-label">${t('signLabelPassword')}</label>
                                <input type="password" class="form-control" mu-id="password" mu-bind="password" autocomplete="current-password" name="password" />
                                <div class="d-flex-row">
                                    <div class="flex-grow-1" mu-id="pVisiblePassword">
                                        <input class="form-check-input" type="checkbox" value="" mu-id="visiblePassword">
                                        <label class="form-check-label" mu-for="visiblePassword">
                                            ${t('signLabelShowPassword')}
                                        </label>
                                    </div>
                                    <div class="text-align-right flex-grow-1" mu="passwordScore"></div>
                                </div>
                                <div class="error-message" mu-for="error:password"></div>
                            </div>
                    
                            <div class="c-form-pair" mu-id="pPassword2">
                                <label mu-for="password2" class="form-label">${t('signLabelPasswordAgain')}</label>
                                <input type="password" class="form-control" mu="password2#password2" />
                                <div class="error-message" mu-for="error:password2"></div>
                            </div>

                            <div class="c-form-pair" mu="pName">
                                <label mu-for="name" class="form-label">${t('signLabelName')}</label>
                                <input type="text" class="form-control" mu="name#name" autocomplete="name" />
                                <div class="error-message" mu-for="error:name"></div>
                            </div>

                            <div class="mb-3" mu-id="pAgreementWithTheContract">
                                <div class="c-form-pair">
                                    <input class="form-check-input" type="checkbox" value="" mu="agreementWithTheContract#agreementWithTheContract">
                                    <label class="form-check-label" mu-for="agreementWithTheContract">
                                        ${t('signLabelAgreeWith')}
                                    </label>
                                    <span mu="bTermsOfService" class="a">${t('signLabelTermsOfService')}</span>
                                </div>
                                <div class="error-message" mu-for="error:agreementWithTheContract"></div>

                                <div class="c-form-pair" mu="pTrainer">
                                    <input class="form-check-input" type="checkbox" value="" checked="checked" mu="confirmTrainerLink#confirmTrainerLink">
                                    <label class="form-check-label" mu-for="confirmTrainerLink">
                                         ${t('signLabelSetTrainerAs')} <span mu="trainer"></span> ${t('signLabelAsMyTrainer')}
                                    </label>
                                </div>
                            </div>
                        </form>
                                
                        <div class="text-align-center">
                            <hr />
                            <button class="btn--primary" mu="bCreateAccount">${t('signButtonCreateAccount')}</button>
                            <button class="btn--primary" mu="bSetPassword">${t('signButtonSetPassword')}</button>
                            <button class="btn--primary" mu="bLogin">${t('signButtonLogin')}</button>
                            <button class="btn--primary" mu="bPasswordRecovery">${t('signButtonResetPassword')}</button>
                            <button class="btn--primary" mu="bRegisterOrRecovery">${t('signButtonRegisterOrReset')}</button>
                        </div>
                
                    </div>
                </div>
                <div class="text-align-center" mu="pActions">
                    <a class="btn--link" mu-click='bAction: "login"'>${t('signActionLogin')}</a>
                    <a class="btn--link" mu-click="bAction: registerOrRecovery">${t('signStatusRegistration')}</a>
                    <a class="btn--link" mu-click="bAction: registerOrRecovery">${t('signStatusForgotPassword')}</a>
                </div>
            </div>`
        );
    }


    public bAction(ev: Event, action: UiSignAction) {
        this.setupAction(action);
    }

    public setupAction(action: UiSignAction) {
        if (this.action !== action) this.errorMarker.markErrors([]);
        this.action = action;
        this.ui.title.innerText = UiSign.actionTitle[action];
        this.visiblePassword_change();
        this.muVisible(this.action === "createAccount", "bCreateAccount");
        this.muVisible(this.action === "login", "bLogin");
        this.muVisible(this.action === 'newPassword', 'bSetPassword');
        this.muVisible(this.action === "passwordRecovery", "bPasswordRecovery");
        this.muVisible([/* "registerOrRecovery",*/ "createAccount"].includes(this.action), "pAgreementWithTheContract");
        this.muVisible(this.action === "registerOrRecovery", "bRegisterOrRecovery");

        this.muVisible(!["passwordRecovery", "registerOrRecovery"].includes(this.action), [ "pPassword", "pVisiblePassword" ]);
        this.muVisible(this.action == "logged", "logged");
        this.muVisible(this.action == "start", "pStart");
        this.muVisible(this.action != "logged" && this.action != "start", "noLogged");
        this.muVisible(this.action == "createAccount", "pName");
        this.muVisible([ "createAccount", "newPassword" ].includes(this.action), "passwordScore");

        this.muVisible(['login', 'registerOrRecovery'].includes(action), 'pActions');

        this.ui.email.disabled = ['createAccount', 'newPassword'].includes(action);
    }

    async bLogout_click() {
        await DataStore.get().logout();
        this.checkLoged();
    }

    bToApp_click() {
        redirect(this.appUrl);
    }

    public visiblePassword_change() {
        const vis = this.ui.visiblePassword.checked;
        this.ui.password.type = vis ? "text" : "password";
        this.muVisible(!vis && [ "createAccount", "newPassword" ].includes(this.action), "pPassword2");
    }

    public action : UiSignAction = "start";

    public static actionTitle : Record<UiSignAction, string> = {
        login: t("signStartLogin"),
        passwordRecovery: t("signActionPasswordRecovery"),
        createAccount: t("signActionCreateAccount"),
        logged: t("signActionLogged"),
        registerOrRecovery: t("signActionRegisterOrRecovery"),
        newPassword: t("signActionNewPassword"),
        start: t("signActionStart"),
    }

    async afterIndex() {
        // @ts-ignore
        this.errorMarker = new ErrorMarker(this);
        super.afterIndex();
        await this.checkLoged();
        this.muVisible(false, "message");
        this.muVisible(true, '.');
        if (this.email) {
            this.ui.email.value = this.email;
        }
        this.muVisible(this.trainers && (this.trainers.length > 0), 'pTrainer');
        if (this.trainers) {
            this.ui.trainer.textContent = this.trainers.map(tr => tr.name + ' (' + tr.email + ')').join(', ');
        }
        if (this.ui.startLoader) this.muVisible(false, 'startLoader');
    }

    private async checkLoged() {
        this.setLogged(await DataStore.get().getCurrentUser());
    }

    protected async setLogged(res: Account|null) {
        this.setupAction(res
            ? "logged"
            : (this.action != "logged" ? this.action : "login")
        );
        this.ui.loggedEmail.innerText = res ? res.email : "";
    }

    password_input() {
        this.ui.passwordScore.textContent = Passwords.computeScore(this.ui.password.value).toString();
    }

    async bCreateAccount_click() {
        let errls = new ErrorList();
        this.validatePassword(errls);
        if (this.ui.name.value == '')
            errls.add('name', t('signErrorEnterName'));
        if (!this.ui.agreementWithTheContract.checked)
            errls.add('agreementWithTheContract', t('signErrorMustAgreeToTerms'));
        if (errls.isValid()) {
            const res = await DataStore.get().tl.registerFinalize(
                this.tokenWithId!,
                {
                    password: this.ui.password.value,
                    name: this.ui.name.value,
                    trainerLinks: this.trainers.map(tr => ({ id: tr.id, token: tr.token })),
                }
            );
            if (res.status === 'ok') {
                this.actionConfirm(t('signSuccessRegistrationComplete'));
                this.setupAction('login');
                //todo: redirect
            } else {
                addFlash(t('signErrorRegistrationFailed') + res.errors.map((err: ErrorListMessage) => err.message).join(', '));
                errls = res.errors;
            }
        }
        this.errorMarker.markErrors(errls);
    }

    async bLogin_click() {
        const errls = new ErrorList();
        if (this.ui.password.value == '')
            errls.add('password', t('signErrorEnterPassword'));
        if (this.ui.email.value == '')
            errls.add('email', t('signErrorEnterEmail'));

        if (errls.isValid()) {
            const res = await DataStore.get().loginUser(
                this.ui.email.value,
                this.ui.password.value,
            );
            if (res) {
                //todo: redirect
                redirect(this.appUrl);
            } else {
                errls.add('email', t('signErrorInvalidCredentials'));
            }
        }
        this.errorMarker.markErrors(errls);
    }

    async bPasswordRecovery_click() {

    }

    async bSetPassword_click() {
        const errls = new ErrorList();
        this.validatePassword(errls);
        this.errorMarker.markErrors(errls);
        if (errls.isValid()) {
            const res = await DataStore.get().setPassword(
                this.tokenWithId!,
                this.ui.password.value
            );
            this.errorMarker.markErrors(res.errors);
            if (res.status === 'ok') {
                this.actionConfirm(t('signSuccessPasswordChanged'));
                this.setupAction('login');
                //todo: redirect
            } else {
                this.actionConfirm(
                    t('signErrorPasswordChangeFailed')
                    + res.errors.map(err => err.message).join(', ')
                );
            }
        }
    }

    private validatePassword(errls: ErrorList) {

        if (!this.ui.visiblePassword.checked && this.ui.password.value !== this.ui.password2.value)
            errls.add('password2', t('signErrorPasswordMismatch'));
        if (this.ui.password.value == '')
            errls.add('password', t('signErrorEnterPassword'));
        if (Passwords.computeScore(this.ui.password.value) < 700)
            errls.add('password', t('signErrorPasswordTooWeak'));
    }

    async bRegisterOrRecovery_click() {
        const res = await DataStore.get().registerOrRecovery(this.ui.email.value);
        this.errorMarker.markErrors(res.errors);
        if (res.status !== "error") {
            this.actionConfirm(t('signSuccessEmailSent').replace('{email}', this.ui.email.value), true);
        } else {
            this.actionConfirm(t('signErrorRequestFailed'), false);
        }
    }

    private actionConfirm(message: string, hideControls: boolean = true) {
        this.ui.message.textContent = message;
        this.muVisible(true, "message");
        if (hideControls) this.muVisible(false, "noLogged");
    }
}

export type UiSignAction = "newPassword"|"login"|"createAccount"|"passwordRecovery"|"logged"|"registerOrRecovery"|"start";
